



import { Component, Vue } from 'vue-property-decorator';
import {MetaEntry, MetaUtil} from '@/util/MetaUtil';

import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue';
import CustomSectionHeader from '@/components/CustomSectionHeader.vue';
import MetaItem from '@/components/device/meta/MetaItem.vue';


import tippy from 'tippy.js';
import {HttpResponse} from "@/types/http";

@Component({
  components: {
    VueError,
    Loading,
    CustomSectionHeader,
    MetaItem
  }
})
export default class MetaSection extends Vue {
  httpBusy = false;
  error = '';
  success = '';
  editMode = false;
  localEntryList:{label:string, valueList:any[]}[] = [];

  // internal dependencies
  private metaUtil:MetaUtil = new MetaUtil();
  
  async mounted() {
    tippy('[data-tippy-content]', { arrow: true });
    this.resetLocalEntryList();
  }

  resetLocalEntryList() {
    this.localEntryList = this.metaUtil.metaToEntryList(this.getMeta())
  }

  onItemUpdated(item:{index: number, label:string, valueList:any[]}) {
    const localItem = this.localEntryList[item.index];

    if(!localItem)
      return;

    // we update the local item
    localItem.label = item.label;
    localItem.valueList = item.valueList;

  }

  onItemRemoved(item:{index:number}) {

    // we remove the items 
    const localItem = this.localEntryList[item.index];

    this.localEntryList.splice(item.index, 1);
  }
  

  switchToEdit() {
    this.editMode = true;

    // if we switch to edit mode and there was no device metadata let's add 1 emtpy entry
    if(this.localEntryList.length === 0)
      this.addNew();
  }

  cancel() {
    this.editMode = false;

    // we reset the local entry list
    this.resetLocalEntryList();

    this.error = '';
    this.success = '';
  }

  protected getMeta(): Record<string, string | number | boolean | string[] | number[]> {
    throw new Error('getMeta must be implemented in the derived class');
  }

  protected async saveMeta(newMeta: Record<string, string | number | boolean | string[] | number[]>): Promise<HttpResponse> {
    throw new Error('saveMeta must be implemented in the derived class');
  }

  async save() {

    this.error = '';
    this.success = '';
  
    const newMeta = this.metaUtil.entryListToMeta(this.localEntryList);

    this.httpBusy = true;

    this.error = '';

    const reply = await this.saveMeta(newMeta);

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.setError(`Unable to update custom metadata: ${reply.errorMsg}`);


    // we get out of the edit mode
    this.editMode = false;

    // we rebuild the local list
    this.resetLocalEntryList();
  }

  errorTimeout:number = -1;
  setError(error:string) {
    if(this.errorTimeout !== -1)
      clearTimeout(this.errorTimeout);

    this.error = error;

    this.errorTimeout = window.setTimeout(() => this.error = '', 3000);
  }

  addNew() {
    // we add a new entry
    this.localEntryList.push({label: '', valueList:[]});
  }

  get showNoEntriesEdit() {
    return this.localEntryList.length === 0 && this.editMode;
  }

  get showNoEntriesView() {
    return this.localEntryList.length === 0 && !this.editMode;
  }
}

